import type { SortDropdownOption } from '@/shared/ui/SortDropdown'

import type { MissionSortOption } from '../domain/sortMissionItems'

export const MISSION_SORT_OPTIONS: (SortDropdownOption & { value: MissionSortOption })[] = [
  { value: 'inProgress', label: 'Em andamento' },
  { value: 'mostProgress', label: 'Maior progresso' },
  { value: 'az', label: 'A-Z' }
]
